import type { FlexCode, FlexGlCode, HighnoteTransactionEvent } from 'API';
import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';

interface FlexProjectDropdownProps {
  selectedGlCode?: FlexGlCode | null;
  selectedProject?: FlexCode | null;
  onValueChange: (option: FlexCode | null) => void;
  disabled?: boolean;
  disableHeader?: boolean;
  placeholder?: string | null;
  transaction?: HighnoteTransactionEvent;
}

const FlexProjectDropdown = ({
  selectedGlCode = null,
  selectedProject = null,
  onValueChange,
  disabled,
  disableHeader = false,
  transaction,
}: FlexProjectDropdownProps) => {
  return (
    <CodingEntityDropdown<FlexCode>
      erpType="flex"
      entityType="projects"
      selectedItem={selectedProject}
      selectedGlCode={selectedGlCode}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      cardGroupId={transaction?.cardGroupId || undefined}
    />
  );
};

export default FlexProjectDropdown;
